/* * @Author: mikey.zhaopeng * @Date: 2025-05-05 20:34:39 * @Last Modified by:
mikey.zhaopeng * @Last Modified time: 2025-05-05 20:34:39 */强制排查的结果
<template>
  <div class="qiangzhipaichajieguo">
    <el-dialog :visible.sync="qiangzhijieguoVisible"  z-index="2000" >
      <div class="content" v-if="type === 2">
        <div class="titleStyle">
          <img src="@/assets/image/icon_success.png" alt="" srcset="" v-if="code === 1" />
          <img src="@/assets/image/icon_error.png" alt="" srcset="" v-if="code === 0" />
          <div class="title">查询结果</div>
        </div>
        <div class="title2">
          {{ title }}
        </div>
        <div class="text" v-if="code === 1">
          {{ advice }}
        </div>
        <div class="noneText" v-if="code === 0">
          <img src="@/assets/image/none.png" class="img" alt="" srcset="" />
          <div class="desc">“此地暂无数据，无法提供建议”</div>
        </div>
      </div>

      <div class="content" v-if="type === 1">
        <div class="titleStyle">
          <img src="@/assets/image/icon_success.png" alt="" srcset="" />
          <div class="title">查询结果</div>
        </div>
        <div class="text" style="text-align: center">
          {{ advice }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      title: "",
      advice: "",
      code: 0,
    };
  },
  created() {},
  computed: {
    ...mapState("qiangzhi", ["type", "cityId"]),
    qiangzhijieguoVisible:{
      get() {
        return this.$store.state.qiangzhi.qiangzhijieguoVisible
      },
      set(val) {
        this.setQiangzhijieguoVisible(val)
      }
    }
  },
  watch: {
    qiangzhijieguoVisible() {
      if (this.qiangzhijieguoVisible) {
        this.getEnforceAdviceDetail();
      }
    }
  },
  methods: {
    ...mapActions("qiangzhi", ["setQiangzhijieguoVisible"]),

    async getEnforceAdviceDetail() {
      const { type, cityId } = this;
      const { status, data } = await this.$api.getEnforceAdviceDetail({
        type,
        cityId,
      });
      if (status === 200) {
        this.title = data.title;
        this.code = data.code;
        this.advice = data.advice?.advice;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.qiangzhipaichajieguo {
  z-index: 2018;
  .content{
    padding: 0;
  }
  .titleStyle {
    display: flex;
    gap: 6px;
    align-items: center;
    justify-content: center;
    img {
      width: 18px;
      height: 18px;
    }
  }
  .title2 {
    text-align: center;

    font-family: "Noto Sans SC";
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0em;

    /* 文字/标题 */
    color: #262626;
    margin-top: 16px;
  }
  .text {
    margin-top: 10px;
    padding: 0 40px;
    padding-bottom: 26px;

    font-family: "Noto Sans SC";
    font-size: 14px;
    font-weight: normal;
    line-height: 24px;
    letter-spacing: 0em;

    color: #666666;
  }
  .noneText {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 26px;
    .img {
      width: 134px;
      height: 87px;
      margin-top: 16px;
    }
    .desc {
      font-family: "Noto Sans SC";
      font-size: 14px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: 0.1px;

      /* 文字/辅助 */
      color: #999999;
      margin-top: 10px;
    }
  }
}
</style>
